import InputField from "@components/fields/input-field";
import SwitchField from "@components/fields/switch-field";
import classnames from "classnames";

// One half of the batch — the brand admin or the publisher. The switch decides
// whether this side goes into the array at all, and the schema only demands the
// fields of a side that is switched on.
const HolderSideFields = ({ prefix, title, subtitle, methods, enabled }) => {
    const { control, formState: { errors } } = methods;

    return (
        <div
            className={classnames(
                "rounded-xl border bg-white p-5 shadow-sm transition-colors",
                enabled ? "border-gray-200" : "border-dashed border-gray-300 opacity-60"
            )}>
            <div className="flex items-start justify-between gap-3">
                <div>
                    <h3 className="text-sm font-semibold text-gray-900">{title}</h3>
                    <p className="mt-0.5 text-xs text-muted">{subtitle}</p>
                </div>
                <SwitchField control={control} name={`create_${prefix}`} id={`create-${prefix}`} />
            </div>

            <div className="mt-4">
                <InputField
                    control={control}
                    errors={errors}
                    name={`${prefix}_name`}
                    id={`${prefix}-name`}
                    label="Name"
                    placeholder="aff 5"
                    disabled={!enabled}
                    required />
                <InputField
                    control={control}
                    errors={errors}
                    name={`${prefix}_email`}
                    id={`${prefix}-email`}
                    label="Email"
                    placeholder="bharat.rana@trackier.com"
                    disabled={!enabled}
                    required />
                <InputField
                    control={control}
                    errors={errors}
                    name={`${prefix}_ext_id`}
                    id={`${prefix}-ext-id`}
                    label="Holder external id"
                    disabled={!enabled}
                    desc="Prefilled — change it if the platform already has an id for this login"
                    required />
                <InputField
                    control={control}
                    errors={errors}
                    name={`${prefix}_password`}
                    id={`${prefix}-password`}
                    type="password"
                    label="Password"
                    disabled={!enabled}
                    required />
            </div>
        </div>
    );
};

export default HolderSideFields;
